<nz-modal
  [nzWidth]="'520px'"
  [(nzVisible)]="isNewResumeVisible"
  [nzTitle]="'Upload Resume'"
  (nzOnCancel)="onCancelResumeClick()"
  [nzOkText]="null"
  [nzCancelText]="null"
>
  <ng-container *nzModalContent>
    <div class="vertical-large">
      <nz-upload
        nzType="drag"
        [nzSize]="3000"
        [nzMultiple]="false"
        [nzCustomRequest]="uploadFileHandler"
        (nzChange)="handleChange($event)"
        [nzAccept]="['.pdf']"
      >
        <p class="ant-upload-drag-icon">
          <span nz-icon nzType="inbox"></span>
        </p>
        <p class="ant-upload-text">Drag and drop or click to select</p>
        <p class="ant-upload-hint">Please upload a PDF smaller than 3MB.</p>
      </nz-upload>
    </div>
  </ng-container>
</nz-modal>
